import TemplateView from "../../../TemplateView"
import {MODE} from "../UserPanelContainer"
import WorkScheduleTable from './workSchedule/WorkScheduleTable'

export default class WorkSchedule extends TemplateView {
    constructor({
        id,
        mode,
        scrollTo = () => {},
        onInitialScheduleChanged = () => {},
        onWorkScheduleChanged = () => {},
        deleteWorkSchedule = () => {},
        addNewSchedule = () => {},
        refreshScrollCb = () => {},
        subscribeSelectorOnScroll = () => {},
    }) {
        super()
        this.id = id
        this.updateOnInit = false
        this.mode = mode

        this.isEditMode = this.mode === MODE.EDIT
        this.scrollTo = scrollTo

        this.callbacks = {
            onInitialScheduleChanged,
            onWorkScheduleChanged,
            deleteWorkSchedule,
            addNewSchedule,
            refreshScrollCb,
            subscribeSelectorOnScroll,
        }

        this.state = {
            userManagementData: null,
            accountSettings: null,
            currentTime: null,
            readOnly: false,

            updating: false,
        }

        this.onAnyStatePropertyDeeplyChanged([
                'userManagementData',
                'accountSettings',
                'currentTime'
            ],
            (state) => {
                this.workScheduleTable.setState({
                    isDefaultInitialSchedule: state.accountSettings.defaultInitialSchedule,
                    initialSchedule: state.accountSettings.initialSchedule,
                    workSchedule: state.accountSettings.workSchedule,
                    defaultWorkSchedule: state.userManagementData.defaultWorkSchedule,

                    currentDate: state.currentTime,
                    weekStartDay: state.userManagementData.weekStartDay,
                    invertedDays: state.userManagementData.invertedDaysMap,
                    decimalSeparator: state.userManagementData.decimalSeparator,
                })
            })

        this.onStatePropertyChanged('updating', updating => this.workScheduleTable.setState({updating}))
        this.onStatePropertyChanged('readOnly', readOnly => this.workScheduleTable.setState({readOnly}))
    }

    templateHtml() {
        return "<div class='workScheduleSection'/>"
    }

    afterRender() {
        this.workScheduleTable = new WorkScheduleTable({
            readOnly: false,
            editMode: this.isEditMode,
            scrollTo: this.scrollTo,
            onWorkScheduleChanged: this.callbacks.onWorkScheduleChanged,
            onInitialScheduleChanged: this.callbacks.onInitialScheduleChanged,
            deleteWorkSchedule: this.callbacks.deleteWorkSchedule,
            addNewSchedule: this.callbacks.addNewSchedule,
            refreshScrollCb: this.callbacks.refreshScrollCb,
            subscribeSelectorOnScroll: this.callbacks.subscribeSelectorOnScroll,
        }).init(this.getEl())
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/WorkSchedule.js